// removed by extract-text-webpack-plugin
module.exports = {"UgcAssignment__removeButton":"UgcAssignment__removeButton","ugcAssignmentRemoveButton":"UgcAssignment__removeButton"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/client/UgcAssignment.css
// module id = 678
// module chunks = 0